// Session storage keys
export const SESSION_KEYS = {
  AUTH_VALIDATED: 'auth_validated',
  AUTH_STATE: 'auth_state',
  SESSION_ID: 'session_id',
  SLAYLISTS: 'slaylist-selector-storage',
};
